import React, { useState } from 'react';
import logo_black from '../images/logo-black.png';
import { Link } from 'gatsby';

const Navigation = props => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <nav id="header" className="fixed w-full z-30 top-0 text-white bg-white shadow header">
            <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
                <Link to="/" className="pl-4 flex items-center">
                    <div className="toggleColour py-2 no-underline hover:no-underline logoContainer">
                        <img className="pr-2 max-h-10 md:max-h-14" src={logo_black} alt="logo" />
                        <div className="flex flex-col justify-center">
                            <div className="text-2xl md:text-3xl leading-none">MEXÍA</div>
                            <div className="text-xs tracking-tight uppercase">Massage & Bodywork</div>
                        </div>
                    </div>
                </Link>

                {/* Mobile Menu */}
                <div className="flex items-center gap-4 pr-4 md:hidden">
                    {/* Hamburger Icon */}
                    <button
                        onClick={toggleMenu}
                        className="flex flex-col gap-1 cursor-pointer focus:outline-none"
                        aria-label="Toggle menu"
                    >
                        <span className={`w-6 h-0.5 bg-black transition-all ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                        <span className={`w-6 h-0.5 bg-black transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></span>
                        <span className={`w-6 h-0.5 bg-black transition-all ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                    </button>

                    {/* Book Button */}
                    <Link to="/booking" className="font-bold rounded-full py-2 px-4 shadow opacity-75 gradient text-white">
                        Book
                    </Link>
                </div>

                {/* Mobile Dropdown Menu */}
                {isMenuOpen && (
                    <div className="absolute top-16 right-0 bg-white text-black shadow-lg rounded-lg py-4 w-48 z-20 md:hidden">
                        <Link
                            to="/treatments"
                            onClick={closeMenu}
                            className="block px-6 py-2 hover:bg-gray-100 no-underline text-black"
                        >
                            Treatments
                        </Link>
                        <Link
                            to="/specialists"
                            onClick={closeMenu}
                            className="block px-6 py-2 hover:bg-gray-100 no-underline text-black"
                        >
                            Specialists
                        </Link>
                        <Link
                            to="/giftcard"
                            onClick={closeMenu}
                            className="block px-6 py-2 hover:bg-gray-100 no-underline text-black"
                        >
                            Gift Cards
                        </Link>
                    </div>
                )}

                {/* Desktop Menu */}
                <div className="hidden md:flex md:items-center md:w-auto mt-2 md:mt-0 bg-white md:bg-transparent text-black p-4 md:p-0 z-20" id="nav-content">
                    <ul className="list-reset md:flex justify-end flex-1 items-center">
                        <li className="navItem">
                            <Link to="/treatments" className="inline-block py-2 pr-6 text-black no-underline" href="#">
                                Bodywork & Treatments
                            </Link>
                        </li>
                        <li className="navItem">
                            <Link to="/specialists" className="inline-block py-2 pr-6 text-black no-underline" href="#">
                                Specialists
                            </Link>
                        </li>
                        <li className="navItem">
                            <Link to="/giftcard" className="inline-block py-2 pr-6 text-black no-underline" href="#">
                                Gift Cards
                            </Link>
                        </li>
                    </ul>
                    <Link to="/booking" className="mx-auto md:mx-0 font-bold rounded-full mt-4 md:mt-0 py-2 px-8 shadow opacity-75 gradient text-white" href="#">
                        Book Now
                    </Link>
                </div>
            </div>
        </nav>
    )
}

Navigation.defaultProps = {
    showButton: true
}

export default Navigation;
